module.exports = __webpack_public_path__ + "img/everyday-places-cover.8cfc3314.png";